import apiRequestCommon from './index'

export default {
  // インテックQRコード取得 API
  path: '/v1/getIntecQr',

  async get (tsid, otoken, ssCode, appVersionHeader) {
    await window.callNativeHTTPX()
    const headers = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'X-CLS-App-Version': appVersionHeader
    }
    const body = {
      tsid,
      otoken,
      ssCode
    }
    return apiRequestCommon.post(this.path, body, {
      headers
    })
  }
}
